import { WIDGET_TYPE } from '@/types/constants';

export const getUtmParameters = (
  url: string,
  widgetType?: WIDGET_TYPE,
): string => {
  const utmSource = 'brainfish';
  let utmMedium = '';

  // Determine utm_medium based on widget type
  switch (widgetType) {
    case WIDGET_TYPE.HELP:
      utmMedium = 'help_center';
      break;
    case WIDGET_TYPE.AGENT_ASSIST:
      utmMedium = 'popup_widget';
      break;
    case WIDGET_TYPE.SEARCH:
    default:
      utmMedium = 'search_widget';
      break;
  }

  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('utm_source', utmSource);
    urlObj.searchParams.set('utm_medium', utmMedium);

    return urlObj.toString();
  } catch (error) {
    // If URL parsing fails, return the original URL
    console.warn('Invalid URL:', url);

    return url;
  }
};
